<template>
  <div>
    <slot></slot>
    <div
      :class="{ smallFonts }"
      v-html="renderedHTML"></div>
  </div>
</template>

<script>
import _ from 'lodash';

import MarkdownMixins from 'components/Widgets/MagicTextBox/MarkdownMixins';

export default {
  name: 'magic-markdown',

  mixins: [MarkdownMixins],

  beforeMount() {
    if (this.$slots.default) {
      this.sourceData = '';
      for (let i = 0; i < this.$slots.default().length; i += 1) {
        this.sourceData += this.$slots.default()[i].text;
      }
    }

    this.$watch('source', () => {
      this.sourceData = this.prerender(this.source);
      this.render();
      this.$forceUpdate();
    });

    this.watches.forEach((v) => {
      this.$watch(v, () => {
        // Source is already watched.
        if (v === 'source') return true;
        this.$forceUpdate();
        return true;
      });
    });
  },

  computed: {
    tocLastLevelComputed() {
      return this.tocLastLevel > this.tocFirstLevel ?
        this.tocLastLevel : this.tocFirstLevel + 1;
    },
  },

  created() {
    this.initMd();
    this.render();
  },

  data() {
    return {
      renderedHTML: '',
      sourceData: this.source,
    };
  },

  emits: [
    'rendered',
  ],

  methods: {
    render() {
      const outHtml = this.renderMDStringToHTML(this.sourceData, this.show);
      this.$emit('rendered', outHtml);
      this.renderedHTML = outHtml;
    },
  },

  props: {
    watches: {
      type: Array,
      default: () => ['source', 'show'],
    },
    source: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
    highlight: {
      type: Boolean,
      default: true,
    },
    html: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Boolean,
      default: false,
    },
    xhtmlOut: {
      type: Boolean,
      default: true,
    },
    breaks: {
      type: Boolean,
      default: true,
    },
    linkify: {
      type: Boolean,
      default: true,
    },
    typographer: {
      type: Boolean,
      default: true,
    },
    langPrefix: {
      type: String,
      default: 'language-',
    },
    quotes: {
      type: String,
      default: '“”‘’',
    },
    tableClass: {
      type: String,
      default: 'table',
    },
    taskLists: {
      type: Boolean,
      default: true,
    },
    smallFonts: {
      type: Boolean,
      default: false,
    },
    anchorAttributes: {
      type: Object,
      default: () => ({
        target: '_blank',
        rel: 'noopener noreferrer',
      }),
    },
  },
};
</script>

<style scoped>
  .smallFonts :deep(h1) { font-size: 1em; }
  .smallFonts :deep(h2) { font-size: 1em; }
  .smallFonts :deep(h3) { font-size: 1em; }
  .smallFonts :deep(h4) { font-size: 1em; }
  .smallFonts :deep(h5) { font-size: 1em; }
  .smallFonts :deep(h6) { font-size: 1em; }
</style>
